import lightGallery from 'lightgallery';

export default class SimpleGallery {
  constructor(element) {
    this.element = element;
    this.init();
  }

  init() {
    this.initLightGallery();
  }

  initLightGallery() {
    const triggers = document.querySelectorAll('.js-lightgallery-trigger');

    if (triggers && window.galleryImages) {
      const dynamicGallery = lightGallery(triggers, {
        counter: false,
        download: false,
        dynamic: true,
        dynamicEl: window.galleryImages,
        licenseKey: '1111-1111-111-1111',
      });

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const currentThumb = document.querySelector(
            '.swiper-slide-thumb-active .simple-gallery__thumbs-btn',
          );
          const currentThumbIndex = parseInt(currentThumb.dataset.index, 10);
          dynamicGallery.openGallery(currentThumbIndex);
        });
      });
    }
  }
}
